<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'menu-list'

  export default {
    name: 'MenuList',
    components: {},
    mixins: [ bem ],
    render: function (createElement) {
      let items = null

      const that = this

      if (this.$slots && this.$slots.default && Array.isArray(this.$slots.default)) {
        items = []

        this.$slots.default.forEach(function (slot) {
          if (typeof slot.tag !== 'undefined') {
            const isSelected = slot.data.attrs['data-is-selected'] && `${that.ns}__item--is-selected`

            const item = createElement(
              'li',
              {
                class: [
                  `${that.ns}__item`,
                  isSelected
                ]
              },
              [slot]
            )

            items.push(item)
          }
        })
      }

      const list = createElement(
        'ul',
        {
          class: this.classnames
        },
        items
      )

      return list
    },
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/js/components/MenuList.vue